import { externalRedirect } from '@americanexpress/one-app-ducks';
import { getAkamaiDomain } from '../selectors/getConfigSelectors';

export const akamaiRedirectHook = (
  { getState, dispatch },
  path
) => async (nextState, replace, callback) => {
  const state = getState();
  const akamaiDomain = getAkamaiDomain(state);

  dispatch(externalRedirect(`${akamaiDomain}/${path}`, { isPermanent: true }));

  return callback();
};
